import PubSub from "underpub-js";

var NavBar = function(options){

  this.options = {
    $el: false
  };

  $.extend(true, this.options, options);

  this.$menuButton = this.options.$el.find(".menu-button");

};

NavBar.prototype.init = function(){

  var self = this;

  this.options.$el.find(".select-location").on("click", function(){
  	PubSub.publish("showLanguageSelectorModal")
  });

  //
  // When the MobileNavOverlay is clickd on
  //

  PubSub.subscribe("deactivateNavBar", function(){
    self.options.$el.removeClass('is-active');
    self.$menuButton.removeClass("is-active");
    self.$menuButton.find(".hamburger").removeClass("is-active");
  });


  //
  // Menu click handler
  //
  this.$menuButton.on("click", function(){

    var $el = $(this);

    if($el.hasClass("is-active"))
    {

      if(window.Breakpoint.value === "xsmall" || window.Breakpoint.value === "small"){
        PubSub.publish("hideMobileNavOverlay");
        self.options.$el.removeClass('is-active');
      }else{
        PubSub.publish("hideNavMenu");
      }

    }
    else
    {

      if(window.Breakpoint.value === "xsmall" || window.Breakpoint.value === "small"){
        PubSub.publish("showMobileNavOverlay");
        self.options.$el.addClass('is-active');
      }else{
        PubSub.publish("showNavMenu");
      }

    }

    $el.toggleClass("is-active");
    $el.find(".hamburger").toggleClass("is-active");

  });

};

export default  NavBar;
